function timersCash(){
    this.storeObj={};
    var thc=this;
    _externalEvents.on("moduleClear",function(){
        thc.clear();
    });
}
timersCash.prototype={
    clear:function(){
        this.storeObj={};
    },
    addToStorage:function(cash){
        this.storeObj[cash.toString()]=1;
    },
    checkStorage:function(cash){
        var i;
        for(i in this.storeObj){
            if(bigInt(i).lesserOrEquals(cash)){
                delete this.storeObj[i];
                $.updateButtons();
                break;
            }
        }
        
    }
};
var _timerCash= new timersCash();
